module.exports = __webpack_public_path__ + "static/img/22.791d29e2.png";